/**
 * Where to send the user after login.
 *
 * Only the pages Claude / Town link to (`/assistant/...`) use this: they carry
 * a query string the page needs (the OAuth landing forwards it to the backend
 * unchanged), so landing on `/` after login would lose it. Everything else
 * keeps going to `/` as before.
 *
 * sessionStorage, because Login hard-navigates (window.location) and router
 * state would not survive it.
 */
const RETURN_TO_KEY = 'auth_return_to';
const ALLOWED_PREFIX = '/assistant/';

// Same-origin paths only — never `//host` or a full URL.
const isSafe = (path) =>
  typeof path === 'string' && path.startsWith(ALLOWED_PREFIX) && !path.startsWith('//');

export const rememberReturnTo = (path) => {
  if (!isSafe(path)) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    /* storage blocked — the user lands on / instead */
  }
};

/** Reads and clears it, so a later login doesn't reuse a stale target. */
export const consumeReturnTo = () => {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafe(path) ? path : null;
  } catch {
    return null;
  }
};
